/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/patient/patient.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { PatientRoutingModule } from "./patient-routing.module";
import * as i0 from "@angular/core";
export class PatientModule {
    constructor() {
    }
}
PatientModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    PatientRoutingModule,
                ],
            },] },
];
/** @nocollapse */
PatientModule.ctorParameters = () => [];
/** @nocollapse */ PatientModule.ɵmod = i0.ɵɵdefineNgModule({ type: PatientModule });
/** @nocollapse */ PatientModule.ɵinj = i0.ɵɵdefineInjector({ factory: function PatientModule_Factory(t) { return new (t || PatientModule)(); }, imports: [[
            PatientRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PatientModule, { imports: [PatientRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(PatientModule, [{
        type: NgModule,
        args: [{
                imports: [
                    PatientRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aWVudC5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9wYXRpZW50L3BhdGllbnQubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUV2QyxPQUFPLEVBQUMsb0JBQW9CLEVBQUMsTUFBTSwwQkFBMEIsQ0FBQzs7QUFPOUQsTUFBTSxPQUFPLGFBQWE7SUFDeEI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixvQkFBb0I7aUJBQ3JCO2FBQ0Y7Ozs7aURBQ1ksYUFBYTt5R0FBYixhQUFhLGtCQUpkO1lBQ1Isb0JBQW9CO1NBQ3JCO3dGQUVVLGFBQWEsY0FIdEIsb0JBQW9CO2tEQUdYLGFBQWE7Y0FMekIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixvQkFBb0I7aUJBQ3JCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuXG5pbXBvcnQge1BhdGllbnRSb3V0aW5nTW9kdWxlfSBmcm9tIFwiLi9wYXRpZW50LXJvdXRpbmcubW9kdWxlXCI7XG5cbkBOZ01vZHVsZSh7XG4gIGltcG9ydHMgOiBbXG4gICAgUGF0aWVudFJvdXRpbmdNb2R1bGUsXG4gIF0sXG59KVxuZXhwb3J0IGNsYXNzIFBhdGllbnRNb2R1bGUge1xuICBjb25zdHJ1Y3RvcigpIHt9XG59XG4iXX0=